// Description of Project One, on its page

export const PortfolioDescription = ({ sentence }) => {
  return <p>{sentence}</p>;
};
